import { configService } from "../index";
import { BaseRequests, BaseRequestsInterface } from "./BaseRequests";
import Gift from "@/models/gift";

export default {
  ...BaseRequests(
    () => configService.noProfileGifts,
    "gift",
    () => new Gift()
  )
} as BaseRequestsInterface;
